var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStmx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.868 3v.004H1l9.5 11.158a3.283 3.283 0 0 1 0 4.256L1 29.578h7.868l8.596-10.098a4.927 4.927 0 0 0 0-6.383L8.868 3zm14.994 20.73a3.29 3.29 0 0 0-2.877-.642l-4.246 1.072 4.426 5.414H31l-7.138-5.843zM31 3h-9.834L16.74 8.413l4.245 1.071a3.282 3.282 0 0 0 2.877-.641L31 3z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStmx);
export default __webpack_public_path__ + "static/media/STMX.78f8b0cc58b93d0e1b76be74ec56d8b4.svg";
export { ForwardRef as ReactComponent };